export default class GenericLocation {
  constructor(
    address,
    number,
    countryId,
    countryDescription,
    stateId,
    stateDescription,
    cityId,
    cityDescription,
    localityId,
    localityDescription,
    complement
  ) {
    this.address = address;
    this.number = number;
    this.countryId = countryId;
    this.countryDescription = countryDescription;
    this.stateId = stateId;
    this.stateDescription = stateDescription;
    this.cityId = cityId;
    this.cityDescription = cityDescription;
    this.localityId = localityId;
    this.localityDescription = localityDescription;
    this.complement = complement;
  }

  getData() {
    return {
      address: this.address,
      number: this.number,
      countryId: this.countryId,
      countryDescription: this.countryDescription,
      stateId: this.stateId,
      stateDescription: this.stateDescription,
      cityId: this.cityId,
      cityDescription: this.cityDescription,
      localityId: this.localityId,
      localityDescription: this.localityDescription,
      complement: this.complement,
    };
  }

  static createLocationFromObject(data) {
    return new GenericLocation(
      data.address,
      data.number,
      data.countryId,
      data.countryDescription,
      data.stateId,
      data.stateDescription,
      data.cityId,
      data.cityDescription,
      data.localityId,
      data.localityDescription,
      data.complement
    );
  }
}
